import { createModel } from 'hox';
import { useState, useEffect } from 'react';
import {
	IItemDetailList,
	ThreeGuaranteesItemDetailList,
	IMaintenanceDetail,
	IMaterialDetailList,
	OtherItemDetailList
} from './vrmBillMaintenanceType';
import { maintenanceService } from './vrmBillMaintenanceService';
import { useGlobalModel } from "@/model/globalModel";
import moment from 'moment';

export const useVrmMaintenanceDetailsModel = createModel(function () {
	const { getCiDictAll, getCiDictByDictCode } = useGlobalModel(() => []);

	//查看详情form
	const [tradeCode, setTradeCode] = useState<string>("");
	const [detailLookForm, setDetailLookForm] = useState<IMaintenanceDetail>({});

	//项目详情列表
	const [itemDetail, setItemDetail] = useState<IItemDetailList[]>([]);
	const [itemDetailVisible, setItemDetailVisible] = useState<boolean>(false);
	//三包详情列表
	const [threeGuaranteesItemDetail, setThreeGuaranteesItemDetail] = useState<ThreeGuaranteesItemDetailList[]>([]);
	const [threeGuaranteesItemDetailVisible, setThreeGuaranteesItemDetailVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [detailMaterialList, setDetailMaterialList] = useState<IMaterialDetailList[]>([]);
	const [detailMaterialListVisible, setDetailMaterialListVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [otherItemDetailList, setOtherItemDetailList] = useState<OtherItemDetailList[]>([]);
	const [otherItemDetailListVisible, setOtherItemDetailListVisible] = useState<boolean>(false);

	useEffect(() => {
		getCiDictAll();
	}, []);

	//维修单信息
	const getDetailOne = async (tradeCode: string) => {
		let { retData } = await maintenanceService.one(tradeCode);
		if (retData != null) {
			const newFrom: IMaintenanceDetail = {
				...retData,
				repairContactName: retData.repairContactName + "(" + retData.repairContactPhone + ")",
				serviceMethod: getCiDictByDictCode(retData.serviceMethod)?.title ?? "",
				serviceType: getCiDictByDictCode(retData.serviceType)?.title ?? "",
				faultClassification: getCiDictByDictCode(retData.faultClassification)?.title ?? "",
				customerVehicleMileage: (retData.customerVehicleMileage ?? "0") as string + "  KM",
				mileage: (retData.mileage ?? "0") as string + "  KM",
				orderType: getCiDictByDictCode(retData.orderType)?.title ?? "",
				invoiceNum: retData.settlementInfo != null ? retData.settlementInfo?.invoiceNum : "",
				invoiceMd5: retData.settlementInfo != null ? retData.settlementInfo?.invoiceMd5 : "",
				invoiceTypeName: retData.settlementInfo != null ? retData.settlementInfo?.invoiceTypeName : "",
				invoiceOperator: retData.settlementInfo != null ? retData.settlementInfo?.invoiceOperator : "",
				invoiceUploadTime: retData.settlementInfo != null ?
					retData.settlementInfo?.invoiceUploadTime != null ?
						moment(retData.settlementInfo?.invoiceUploadTime).format('YYYY-MM-DD HH:mm:ss') : "" : "",

			};
			setDetailLookForm(newFrom);

			setItemDetailVisible(false);
			setThreeGuaranteesItemDetailVisible(false);
			setDetailMaterialListVisible(false);
			setOtherItemDetailListVisible(false);
			itemDetailList(retData.id as string);
			threeGuaranteesItemDetailList(retData.id as string);
			materialList(retData.id as string);
			otherItemList(retData.id as string);
		}
	};

	//维修项目
	const itemDetailList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id, "serviceNature": ["016002", "016003","016004"] } };
		let { retData } = await maintenanceService.itemList(param);
		const { list } = retData;
		setItemDetail(list);
		if (list != null && list.length > 0) {
			setItemDetailVisible(true);
		}
	};

	//三包信息
	const threeGuaranteesItemDetailList = async (id: string) => {
		let param = { "searchItem": { "orderId": id, "search": {} }, "pageNum": 1, "pageSize": 100, "orders": [{ "column": "updateTime", "rule": "DESC" }] };
		let { retData } = await maintenanceService.threeGuaranteesList(param);
		const { list } = retData;
		setThreeGuaranteesItemDetail(list);

		if (list != null && list.length > 0) {
			setThreeGuaranteesItemDetailVisible(true);
		}
	};

	//维修物料
	const materialList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id, "serviceNature": ["016002", "016003","016004"] } }
		let { retData } = await maintenanceService.materialList(param);
		const { list } = retData;
		let newList = list.map(item => ({
			...item,
			totalCount: item.materialAmount,
			actualMoney: item.actualAmount,
			availableUseNum: (item.remainingNum ?? 0) + (item.materialNumber ?? 0),
		}));
		setDetailMaterialList(newList);

		if (list != null && list.length > 0) {
			setDetailMaterialListVisible(true);
		}
	};

	//其他项目
	const otherItemList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id } }
		let { retData } = await maintenanceService.otherItemDetailList(param);
		const { list } = retData;
		setOtherItemDetailList(list);

		if (list != null && list.length > 0) {
			setOtherItemDetailListVisible(true);
		}
	};


	return {
		setTradeCode,
		getDetailOne,
		tradeCode,
		detailLookForm,
		itemDetail,
		itemDetailVisible,
		threeGuaranteesItemDetail,
		threeGuaranteesItemDetailVisible,
		detailMaterialList,
		detailMaterialListVisible,
		otherItemDetailList,
		otherItemDetailListVisible
	};

});
